export default __webpack_public_path__ + "static/media/4live.fa836fe0.svg";